var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-icon"},[_c('button',{ref:"moreBtn",staticClass:"icon",on:{"click":function($event){return _vm.setFocus()}}},[_c('SvgIcon',{attrs:{"icon":"more"}})],1),_vm._v(" "),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }